import { Lock, Play } from 'lucide-react';
import { useGoogleSignIn } from './LandingPage';
import { PREVIEW_LIMIT } from '../previewGate';

/**
 * The end of the free preview.
 *
 * Deliberately not a price: the ask here is a sign-in, and what it buys is the
 * 30-day trial the app already gives (Stripe runs it in `mode: "setup"`). Cards
 * come at checkout, after this — the whole point of the preview is that nobody
 * is asked for one before they've seen the app work.
 */
export default function PreviewWall({
  reason,
  onDismiss,
}: {
  /** 'plays' — used up the free clips. 'locked' — tapped a members-only tab. */
  reason: 'plays' | 'locked';
  /** Back to the feed. Omitted when there's nothing to go back to. */
  onDismiss?: () => void;
}) {
  const signIn = useGoogleSignIn();

  return (
    <div className="preview-wall">
      <div className="preview-wall-card">
        <div className="preview-wall-icon">
          {reason === 'plays' ? <Play size={30} strokeWidth={2} /> : <Lock size={30} strokeWidth={2} />}
        </div>

        <h2 className="preview-wall-title">
          {reason === 'plays' ? `That's your ${PREVIEW_LIMIT} free clips` : 'Members only'}
        </h2>

        <p className="preview-wall-body">
          {reason === 'plays'
            ? 'Sign in to keep watching — the next 30 days are free, and you can cancel any time.'
            : 'Your library, favourites and progress live behind a free account. 30 days free, cancel any time.'}
        </p>

        <button type="button" className="preview-wall-cta" onClick={signIn}>
          <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          Continue with Google
        </button>

        {onDismiss && (
          <button type="button" className="preview-wall-back" onClick={onDismiss}>
            Keep looking around
          </button>
        )}
      </div>
    </div>
  );
}
